exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-ad89bb04]{font-family:Nunito,Helvetica,Arial,sans-serif;font-size:30px;font-weight:600;line-height:30px;padding:10px 5px}.badge.badge-warning[data-v-ad89bb04]{color:#fff}.badge.badge-plain[data-v-ad89bb04]{color:#5b6981;background:#f4f7ff}.badge.badge-outline[data-v-ad89bb04]{color:#5b6981;background:#fff;border:1px solid #eaedf3}", ""]);

// exports
